//////////////////////////////////////////////////////////////////
// Listview
//////////////////////////////////////////////////////////////////

jQuery(function ($) {
  if (Cookies.get('zaza-listview')) {
    document.documentElement.setAttribute("listview", "list");
    $('.zaza-listview-button input[type="checkbox"]').prop('checked', true);
  } else {
    document.documentElement.setAttribute("listview", "grid");
  }

  $('.zaza-listview-button input[type="checkbox"]').change(function () {
    var cookieValue = Cookies.get('zaza-listview');
    if (cookieValue) {
      Cookies.remove('zaza-listview');
      document.documentElement.setAttribute("listview", "grid");
    } else {
      Cookies.set('zaza-listview', 'true');
      document.documentElement.setAttribute("listview", "list");
    }
  });
});


// jQuery(document).on('click', '.zaza-listview-button input[type="checkbox"]', function () {
//   location.reload();
// });
